export const opacities = {
  hover: '0.72',
  disabled: '0.36',
};
